@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.signUpForm {
  @include cxy.stack(var(--cxy-spacing-xxsm));
}
.signUpForm .buttonSection button {
  width: 100%;
}
.signUpForm .marketingConsentText {
  font-size: var(--cxy-fontSize-xs);
  line-height: var(--cxy-lineHeight-xxs);
  color: var(--cxy-color-text-default-body);
}

.signUpForm .marketingConsentTextError {
  font-size: var(--cxy-fontSize-xs);
  line-height: var(--cxy-lineHeight-xxs);
  color: var(--cxy-color-error);
}

.errorMessage {
  margin-top: var(--cxy-spacing-xxxsm);
  color: var(--cxy-color-error);
}

.agreeTermsError {
  color: var(--cxy-color-error);
  font-size: var(--cxy-fontSize-xs);
}

.termsContainer {
  @include cxy.stack(var(--cxy-spacing-xxxsm));
}

.termsCheckboxRow {
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-xxxsm);
}

.termsLink {
  font-size: var(--cxy-fontSize-xs);
  text-decoration: underline !important;
  color: var(--cxy-color-content-on-inverse);
}

.termsLinkError {
  font-size: var(--cxy-fontSize-xs);
  color: var(--cxy-color-error);
}

.termsText {
  font-size: var(--cxy-fontSize-xs);
  line-height: var(--cxy-lineHeight-xxs);
  color: var(--cxy-color-text-default-body);
}
.termsText a {
  font-size: var(--cxy-fontSize-xs);
  line-height: var(--cxy-lineHeight-xxs);
  text-decoration: underline;
  color: var(--cxy-color-text-default-body);
}

/* WhoScored theme override */
[data-fpsm-theme='whoscored'] .signUpForm .buttonSection button {
  color: var(--cxy-color-text-default-placeholder);
  text-transform: uppercase;
}
